<template>
    <div class="mt-5 row">
        <div class="mx-auto col-lg-10 col-xs-12">
            <b-breadcrumb :items="items"></b-breadcrumb>
            <div class="card p-3">
                <b-card
                    header="Dados complementares - Requerente"
                    header-tag="header">
                    <b-form @submit="onSubmit" @reset="onReset" inline>

                        <div class="p-0 mb-3 col-12 d-md-flex">
                            <label class="mr-sm-1 col-md-2 p-0" for="data_nascimento">Data Nascimento</label>
                            <b-form-input
                                id="data_nascimento"
                                v-model="form.data_nascimento"
                                type="date"
                                required
                            ></b-form-input>
                        </div>
                        
                        <div class="p-0 mb-3 col-12 d-md-flex">
                            <label class="mr-sm-1 col-md-2 p-0" for="nome_completo">Nome da mãe</label>
                            <b-form-input
                                id="nome_completo"
                                v-model="form.nome_completo"
                                type="text"
                                placeholder="Nome"
                                required
                                class="w-100"
                            ></b-form-input>
                        </div>

                        <div class="p-0 mb-3 col-12 d-md-flex">
                            <label class="mr-sm-1 col-md-2 p-0" for="tipo_documento">Tipo Documento</label>
                            <b-form-select
                                id="tipo_documento"
                                v-model="form.tipo_documento"
                                class="mb-2 mr-sm-1 mb-sm-0"
                                :options="tipos"
                            ></b-form-select>

                            <label class="mr-sm-1 col-md-3 p-0" for="numero_documento">Número documento</label>
                            <b-form-input
                                id="numero_documento"
                                v-model="form.numero_documento"
                                type="text"
                                required
                                class="w-100"
                            ></b-form-input>
                        </div>

                        <div class="p-0 mb-3 col-12 d-md-flex">
                            <label class="mr-sm-1 col-md-2 p-0" for="orgao_emissor">Órgão emissor</label>
                            <b-form-input
                                id="orgao_emissor"
                                v-model="form.orgao_emissor"
                                type="text"
                                required
                                class="col-md-2 mb-2"
                            ></b-form-input>

                            <label class="mr-sm-1 col-md-1 p-0" for="uf_orgao_emissor">UF</label>
                            <b-form-select
                                id="uf_orgao_emissor"
                                v-model="form.uf_orgao_emissor"
                                class="mb-2 mr-sm-1 mb-sm-0"
                                :options="[{ text: 'Choose...', value: null }, 'One', 'Two', 'Three']"
                                :value="null"
                            ></b-form-select>

                            <label class="mr-sm-1 col-md-3 p-0" for="data_validde">Validade documento</label>
                            <b-form-input
                                id="data_validde"
                                v-model="form.data_validde"
                                type="text"
                                required
                                class="w-100"
                            ></b-form-input>
                        </div>

                        <div class="p-0 mb-3 col-12 d-md-flex">
                            <label class="mr-sm-1 col-md-2 p-0" for="cep_endereco">Cep</label>
                            <b-form-input
                                id="cep_endereco"
                                v-model="form.cep_endereco"
                                type="text"
                                required
                                class="col-md-2 mb-2"
                            ></b-form-input>

                            <label class="mr-sm-1 col-md-2 p-0" for="numero_documento">Número</label>
                            <b-form-input
                                id="numero_endereco"
                                v-model="form.numero_endereco"
                                type="text"
                                required
                                class="col-md-2"
                            ></b-form-input>
                        </div>

                        <div class="p-0 mb-3 col-12 d-md-flex">
                            <label class="mr-sm-1 col-md-2 p-0" for="tipo_logradouro">Tipo Logradouro</label>
                            <b-form-input
                                id="tipo_logradouro"
                                v-model="form.tipo_logradouro"
                                type="text"
                                required
                                class="col-md-1 mb-2"
                            ></b-form-input>

                            <label class="mr-sm-1 col-md-2 p-0" for="endereco">Logradouro</label>
                            <b-form-input
                                id="endereco"
                                v-model="form.endereco"
                                type="text"
                                required
                                class="col-md-3 mb-2"
                            ></b-form-input>

                            <label class="mr-sm-1 col-md-2 p-0" for="data_validde">Complemento</label>
                            <b-form-input
                                id="complemento"
                                v-model="form.complemento"
                                type="text"
                                required
                                class="w-100"
                            ></b-form-input>
                        </div>

                        <div class="col text-center">
                            <b-button variant="success">GRAVAR</b-button>
                        </div>

                    </b-form>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "dadoscomplementares",
    data() {
        return {
            form: {
                email: '',
                name: '',
                food: null,
                tipo_documento: null,
                checked: [],
            },
            tipos: [
                    { text: 'Selecione', value: null },
                    { text: 'RG - Registro Geral', value: 'RG' },
                    { text: 'CNH - Carteira Nacional de Habilitação', value: 'CNH' },
                    { text: 'Passaporte', value: 'Passaporte' },
                    { text: 'CTPS - Carteira de Trabalho e Previdência Social', value: 'CTPS' },
                    { text: 'CIE - Carteira de Identidade de Estrangeiros', value: 'CIE' },
                    { text: 'RNE - Registro Nacional de Estrangeiros', value: 'RNE' }
            ],
            items: [
                { text: "Busca beneficiário", to: { name: "home" } },
                { text: "Completar dados", active: true },
            ],
        }
    },
    methods: {
        onSubmit() {

        },
        onReset() {

        }
    }
}
</script>